import { css } from "emotion";
import { InterpolationWithTheme } from "@emotion/core";


export const patientConsSummary: { [key: string]: InterpolationWithTheme<any> } = {
    medicineCard: {
        background: "rgb(246,249,252)",
        margin: "11px 0px",
        padding: "15px"
    },
    medicineName: {
        color: "rgba(0, 0, 0, 0.85)",
        fontFamily: "BrandonTextWeb-Bold",
        fontSize: "17px",
        fontWeight: "bold"
    },
    description: {
        color: "rgb(102, 102, 102)",
        fontFamily: "BrandonTextWeb-Regular",
        fontsize: "14px"
    }
}